import Api from './ApiWAService'

export default {
    get(keyword, pageNumber, pageSize, order) {
        return Api().get(`whatsapp_message_template?keyword=${keyword}&pageNumber=${pageNumber}&pageSize=${pageSize}&orderColumn=${order.column}&orderSort=${order.sort}`);
    },
}